import './shippingToTag.scss';
import { FC } from 'react';
import { TruckIcon } from 'tedooo-web-design-system/icons';
import { Tooltip } from 'tedooo-web-design-system/ui';

import { Countries } from 'constant/countries';

export interface IShippingToTag {
  originCountry: string;
  shippingCountries: string[];
}

const ShippingToTag: FC<IShippingToTag> = ({ originCountry, shippingCountries }) => {
  const countries = shippingCountries.join(', ');

  const isWorldwideShipping = shippingCountries.includes(Countries.WorldWide);

  const renderShippingTo = () => {
    if (isWorldwideShipping) {
      return <span className="tag-text">Ships from {originCountry} to Worldwide</span>;
    }

    if (shippingCountries.length === 1) {
      return <span className="tag-text">{`Only ships to ${countries}`}</span>;
    }

    return (
      <span className="tag-text">
        {`Ships from ${originCountry} to `}
        <Tooltip placement="bottom" text={countries} color="white">
          <span className="selected-countries">selected countries</span>
        </Tooltip>
      </span>
    );
  };

  return (
    <div className="shipping-to-tag-container">
      <TruckIcon />
      {renderShippingTo()}
    </div>
  );
};

export default ShippingToTag;
